import _filter from 'lodash/filter';
import dayjs from 'dayjs';
import { CYOA_NETWORK_IDS } from '../config';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(AdvancedFormat);


export const currencySign = (str) => {
  return (str !== undefined) ? str.charAt(0) : "";
}

export function historyPushState(filterKey1, filterProperty1, query){

  let newurl = "";
  if(query === undefined){
     newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+filterKey1+'='+filterProperty1;
  }else{
    if(query.utm_source && query.utm_campaign && query.utm_medium){
     newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+filterKey1+'='+filterProperty1+
     '&utm_source='+query.utm_source+'&utm_campaign='+query.utm_campaign+"&utm_medium="+query.utm_medium;
   }else{
      newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+filterKey1+'='+filterProperty1;
   }
  }

  if (window.history.pushState) {
      window.history.pushState({path:newurl},'',newurl);
  }
}

export function isInt(value) {
  return !isNaN(value) && parseInt(Number(value),10) === value && !isNaN(parseInt(value, 10));
}


export function calculateDueDate(departure, duration){
  return departure !== "" ? dayjs(departure).subtract(duration, 'days').format("DD MMM YYYY") : "";
}

//Product title for fixed and hoho tours
export function renderProductTitle(product, selectedTourId){
  if(product !== undefined && product.header.product_options !== undefined && product.header.product_options.length > 0){
    const tourName = _filter(product.header.product_options, {'tour_id': selectedTourId})[0];
    return (tourName !== undefined) ? tourName.name : product.header.name;
  }else{
    return product.header.name;
  }
}



export function ieCheck(){
    //Checks IE 6 - 11 and Edge
    const ua = window.navigator.userAgent;
    // return (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) ? true : false;
    return (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident/') > 0) ? true : false;
}


//1. Checks the lockout parameter on the booking > trips > passenger > on_request
//2. Check for CYOA trips with accomodation (disabled pre-auth)
export function checkLockout(bookingGroup, itineraries = null){
  if(Object.keys(bookingGroup).length > 0 && bookingGroup.trips.length > 0){
    const HAS_CYOA = _filter(bookingGroup.trips, (o) => {return o.tour_id === CYOA_NETWORK_IDS["europe"].id || o.tour_id === CYOA_NETWORK_IDS["usa"].id}).length > 0 ? true : false;

    if(HAS_CYOA){
      // Disabled pre-auth
      // return itineraries !== null && itineraries.accomm_total !== "0.00" ? true : false;
      return false;
    }else{
      return bookingGroup.trips[0].passengers[0].on_request ? true : false;
    }
  }

}

export function removeProperty(obj, property){
  return  Object.keys(obj).reduce((acc, key) => {
    if (key !== property) {
      return {...acc, [key]: obj[key]}
    }
    return acc;
  }, {})
}


// export function simulateClick(elem) {
// 	// Create our event (with options)
// 	const evt = new MouseEvent('click', {
// 		bubbles: true,
// 		cancelable: true,
// 		view: window
// 	});
// 	// If cancelled, don't dispatch our event
// 	const canceled = !elem.dispatchEvent(evt);
// };



// WEBPACK FOOTER //
// ./src/helpers/utils.js